export const FALLBACK_LANGUAGE = "de-DE";

export function resolveDefaultApiBaseUrl(): string {
  // Development: Use dynamic hostname resolution with backend port
  if (import.meta.env.DEV) {
    const hostname = typeof window !== "undefined" ? window.location.hostname : "localhost";
    const port = import.meta.env.VITE_API_PORT || "4000";
    // Use HTTPS for local development (backend runs with TLS for connector auth)
    const apiUrl = `https://${hostname}:${port}`;
    console.log("[Config] DEV mode detected, using", apiUrl);
    return apiUrl;
  }

  // Production (Azure Static Web App): Use environment-specific backend URL
  if (typeof window !== "undefined" && window.location.hostname.includes('azurestaticapps.net')) {
    // Production environment
    if (window.location.hostname === 'jolly-water-0f9a5e900.2.azurestaticapps.net') {
      const backendUrl = 'https://intecai-production-h6ajbxe0gphqheds.germanywestcentral-01.azurewebsites.net';
      console.log("[Config] Production mode (Azure), using backend:", backendUrl);
      return backendUrl;
    }

    // Test/Staging environment (default)
    const backendUrl = 'https://intecai-cloud-test-fjfudkc5d5eecrc0.germanywestcentral-01.azurewebsites.net';
    console.log("[Config] Test/Staging mode (Azure), using backend:", backendUrl);
    return backendUrl;
  }

  // Fallback: Use empty string for same-origin proxy
  console.log("[Config] Production mode, using relative URLs (same-origin proxy)");
  return "";
}

export const API_BASE_URL = resolveDefaultApiBaseUrl();

console.log("[Config] Final API_BASE_URL:", API_BASE_URL);

export function detectBrowserLanguage(): string {
  if (typeof navigator !== "undefined") {
    const candidates = Array.isArray(navigator.languages)
      ? navigator.languages
      : navigator.language
        ? [navigator.language]
        : [];

    for (const candidate of candidates) {
      if (typeof candidate === "string") {
        const value = candidate.trim();
        if (value.length > 0) {
          return value;
        }
      }
    }
  }

  return FALLBACK_LANGUAGE;
}
